<app-cabotaje-form-salida-barco
  [blDetails]="blDetails"
  [nationalPorts]="nationalPorts"
  [outputTypes]="outputTypes"
  [boats]="boats"
  [cabotageBatch]="cabotageBatch"
  [locations]="locations"
  [amountsPerYardList]="amountsPerYardList"
  (onTipoSalida)="cambiarSalida($event)"
  *ngIf="tipoSalida === '1' && loader == false"
></app-cabotaje-form-salida-barco>
<app-cabotaje-form-salida-desistimiento
  [blDetails]="blDetails"
  [outputs]="outputs"
  [outputTypes]="outputTypes"
  [tipoTransporte]="transportType"
  [tipoUnidad]="unitType"
  [listTransportLine]="listTransportLine"
  [originsTicket]="originsTicket"
  [cabotageBatch]="cabotageBatch"
  [locations]="locations"
  [amountsPerYardList]="amountsPerYardList"
  (onTipoSalida)="cambiarSalida($event)"
  *ngIf="tipoSalida === '2' && loader == false"
></app-cabotaje-form-salida-desistimiento>
<app-cabotaje-form-salida-merma
  [blDetails]="blDetails"
  [outputTypes]="outputTypes"
  [cabotageBatch]="cabotageBatch"
  [boats]="boats"
  [locations]="locations"
  [amountsPerYardList]="amountsPerYardList"
  (onTipoSalida)="cambiarSalida($event)"
  *ngIf="tipoSalida === '3' && loader == false"
></app-cabotaje-form-salida-merma>
<app-cabotaje-form-salida-traspaso
  [outputTypes]="outputTypes"
  [cabotageBatch]="cabotageBatch"
  [locations]="locations"
  [amountsPerYardList]="amountsPerYardList"
  [batchesAvailableTransfer]="batchesAvailableTransfer"
  (onTipoSalida)="cambiarSalida($event)"
  *ngIf="tipoSalida === '4' && loader == false"
></app-cabotaje-form-salida-traspaso>
<app-output-form-to-another-patio
  [blDetails]="blDetails"
  [outputTypes]="outputTypes"
  [locations]="locations"
  [amountsPerYardList]="amountsPerYardList"
  (onTipoSalida)="cambiarSalida($event)"
  *ngIf="tipoSalida === '5' && loader == false"
></app-output-form-to-another-patio>
<app-cabotaje-form-salida-acuerdo-aduanal
  [blDetails]="blDetails"
  [outputs]="outputs"
  [outputTypes]="outputTypes"
  [tipoTransporte]="transportType"
  [tipoUnidad]="unitType"
  [boats]="boats"
  [listTransportLine]="listTransportLine"
  [originsTicket]="originsTicket"
  [cabotageBatch]="cabotageBatch"
  [locations]="locations"
  [amountsPerYardList]="amountsPerYardList"
  (onTipoSalida)="cambiarSalida($event)"
  *ngIf="tipoSalida === '6' && loader == false"
></app-cabotaje-form-salida-acuerdo-aduanal>
<app-loader class="loader" *ngIf="loader"></app-loader>
<app-overlay
  mensaje="No se puede registrar salida porque el lote no tiene anexos"
  icono="bi bi-info-circle-fill"
  *ngIf="anexos"
></app-overlay>
<app-overlay
*ngIf="overlayError"
[reload]="true"
></app-overlay>
